module.exports = SingleVendor.preact;